import { defineStore } from 'pinia';
import PublisherService from '~/services/PublisherService';

export const usePublisherSummaryStore = defineStore('publisherSummary', {
  state: () => ({
    channelsCount: 0,
    ordersCount: 0,
    newOrdersCount: 0,
    balance: 0,
    unreadMessagesCount: 0,
  }),
  actions: {
    async fetchSummary() {
      try {
        const res: any = await PublisherService.getSummary();
        this.channelsCount = res?.channelsCount ?? 0;
        this.ordersCount = res?.ordersCount ?? 0;
        this.newOrdersCount = res?.newOrdersCount ?? 0;
        this.balance = res?.balance ?? 0;
        this.unreadMessagesCount = res?.unreadMessagesCount ?? 0;
      } catch {
        // silent
      }
    },
  },
});
